import React from 'react'
import { usePermissions } from 'src/hooks/use-permissions'

interface GateProps {
  /**
   * The permission codename required to render children.
   * Follows the '<app_label>.<action>' convention, e.g. 'expenses.create'.
   */
  permission: string
  children: React.ReactNode
}

/**
 * Renders children only when the current user holds the given permission in
 * their active organisation.  If they do not, nothing is rendered — no
 * disabled state, no placeholder.
 *
 * Usage:
 *   <Gate permission="expenses.create">
 *     <Button onClick={handleCreate}>Add Expense</Button>
 *   </Gate>
 */
export const Gate: React.FC<GateProps> = ({ permission, children }) => {
  const { hasPermission } = usePermissions()

  if (!hasPermission(permission)) return null

  return <>{children}</>
}
